
document.addEventListener('DOMContentLoaded', function() {
  const slideshows = document.querySelectorAll('.slideshow');

  slideshows.forEach(slideshow => {
    const slides = slideshow.querySelectorAll('.slideshow__slide');
    let current = 0;
    const autoplaySpeed = parseInt(slideshow.dataset.speed) || 7000;

    slides.forEach((slide, index) => {
      slide.style.opacity = index === 0 ? '1' : '0';
      slide.style.position = 'absolute';
      slide.style.top = '0';
      slide.style.left = '0';
      slide.style.width = '100%';
      slide.style.transition = 'opacity 1s ease-in-out';
    });

    setInterval(() => {
      const next = (current + 1) % slides.length;
      slides[current].style.opacity = '0';
      slides[next].style.opacity = '1';
      current = next;
    }, autoplaySpeed);
  });
});

